import React from 'react'
import { t } from 'ttag'

import { MessageAlert } from 'components/shared/Alerts/MessageAlert/MessageAlert'
import { Form } from 'components/shared/Form/Form'
import { Modal } from 'components/shared/Modal/Modal'
import { fetchDepartments } from 'api/departments'

import { NON_FIELD_ERRORS, getApiError } from 'utils/apiErrors'
import { TEMPLATE_NAME_FIELD, TEMPLATE_DEPARTMENT_FIELD } from './model'
import { TEMPLATE_NAME_LIMIT } from './schema'

import styles from './CopyTemplateModal.module.scss'

export const CopyTemplateModal = ({
  alert,
  form: { control, formState, watch },
  label,
  title,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => (
  <Modal
    className={styles.modal}
    cancelLabel={t`Cancel`}
    confirmLabel={t`Save`}
    {...{ title, onCancel, onClose, onConfirm, isOpen }}
  >
    <Modal.Header />
    <Modal.Content className={styles.content}>
      <MessageAlert
        className={styles.alert}
        message={alert}
        variant="info"
        isInitialised
      />
      <Form>
        <Form.Field
          count={watch(TEMPLATE_NAME_FIELD)?.length}
          error={
            formState.errors?.root?.apiError.message[NON_FIELD_ERRORS] ||
            formState.errors?.[TEMPLATE_NAME_FIELD]?.message
          }
          field="input"
          hint={t`Name needs to be unique.`}
          limit={TEMPLATE_NAME_LIMIT}
          name={TEMPLATE_NAME_FIELD}
          {...{ control, label }}
        />
        <Form.Field
          count={watch(TEMPLATE_DEPARTMENT_FIELD)?.length}
          field="combobox"
          name={TEMPLATE_DEPARTMENT_FIELD}
          error={
            getApiError(formState.errors?.root?.apiError, NON_FIELD_ERRORS) ??
            formState.errors[TEMPLATE_DEPARTMENT_FIELD]?.message
          }
          label={t`Department`}
          placeholder={t`Available Departments`}
          isRequired
          isSearchable
          fetchOptions={[
            fetchDepartments,
            ({ name, id }) => ({ label: name, value: id }),
          ]}
          {...{ control }}
        />
      </Form>
    </Modal.Content>
    <Modal.Footer />
  </Modal>
)
